import { memo } from 'react'
import { createGlobalStyle } from 'styled-components'

export default memo(createGlobalStyle`
* {
  font-family: system-ui, sans-serif;
}
body {
  overflow-x: auto;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  width: 100vw;
  height: 100vh;
  font-family: Arial, Helvetica, sans-serif;
}
p > a {
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
}
#__next {
  height: 100%;
  width: 100%;
}
#root {
  height: 100%;
  width: 100%;
}

`)
